var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWithdraw = function SvgWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.458,
    height: 25.458,
    viewBox: "0 0 25.458 25.458"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e81c5c",
    d: "m6.365 17.678 4.95-4.95-4.95-4.95a1 1 0 0 1 0-1.414 1 1 0 0 1 1.414 0l4.95 4.95 4.95-4.95a1 1 0 0 1 1.414 0 1 1 0 0 1 0 1.414l-4.95 4.95 4.95 4.95a1 1 0 0 1 0 1.414 1 1 0 0 1-1.414 0l-4.95-4.95-4.95 4.95a1 1 0 0 1-1.414 0 1 1 0 0 1 0-1.414",
    "data-name": "Union 6"
  })));
};
export default SvgWithdraw;